/// Route names
export default {
  Home: 'Eligible',
  MemberNonMember: 'Member Non Member',
  Payment: 'Payment',
  ConfirmMembership: 'Confirm Membership',
  ValidateMobile: 'Validate Mobile',
  EnquiryForm: 'Enquiry Form',
  OpenEnquiry: 'Open Enquiry',
  DocPackUpload: 'DocPackUpload',
  Timeout: 'Timeout',
  404: '404',
  Error: 'Error'
};